import { Observable } from 'rxjs';
import { get } from '@/shared/api/http';

export interface MapLayer {
  id: string;
  name: string;
  description: string;
  scope: 'global' | 'operator';
  operator: string | null;
  active_file_url: string | null;
  active_file_name: string | null;
  has_file: boolean;
}

export function getMapLayers(): Observable<MapLayer[]> {
  return get<MapLayer[]>('/api/v1/map-layers/');
}
